import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setApiBaseUrl } from './api/client';
import { initAuth, loadAuthConfig } from './auth/authConfig';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('main.tsx: #root-Element nicht gefunden.');
}

void loadAuthConfig().then((config) => {
  setApiBaseUrl(config.apiBaseUrl);
  initAuth(config);
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
